import {
  API_FORGOT_STEP_ONE,
  API_FORGOT_STEP_THREE,
  API_FORGOT_STEP_TWO,
  API_LOGIN,
  API_LOGOUT,
  API_VERIFY,
} from "./apiPaths";
import axiosMiddleware from "./axiosMiddleware";
// --------------------------------------------------------------------------------
export const loginAPI = ({ email, password }) => {
  let postData = {
    email,
    password,
  };
  return axiosMiddleware({
    method: "post",
    url: API_LOGIN,
    data: postData,
  });
};
export const verifyAPI = ({ email, password, verifyCode }) => {
  let postData = {
    email,
    password,
    verifyCode,
  };
  return axiosMiddleware({
    method: "post",
    url: API_VERIFY,
    data: postData,
  });
};
export const logoutAPI = ({ userID }) => {
  let postData = {
    userID,
  };
  return axiosMiddleware({
    method: "post",
    url: API_LOGOUT,
    data: postData,
  });
};
export const forgotPasswordFirstStepAPI = ({ email }) => {
  let postData = {
    email,
  };
  return axiosMiddleware({
    method: "post",
    url: API_FORGOT_STEP_ONE,
    data: postData,
  });
};
export const forgotPasswordSecondStepAPI = ({ email, token }) => {
  let postData = {
    email,
    token,
  };
  return axiosMiddleware({
    method: "post",
    url: API_FORGOT_STEP_TWO,
    data: postData,
  });
};
export const forgotPasswordThirdStepAPI = ({
  email,
  token,
  newPassword,
  confirmNewPassword,
}) => {
  let postData = {
    email,
    token,
    new_password: newPassword,
    confirm_new_password: confirmNewPassword,
  };
  return axiosMiddleware({
    method: "post",
    url: API_FORGOT_STEP_THREE,
    data: postData,
  });
};
